export default __webpack_public_path__ + "static/media/bg-4.9c93cd38.jpg";